/**
 * Inserts a filter definition in the given node.
 * <filter id="icon-shadow">
 *	<feGaussianBlur in="SourceAlpha" stdDeviation="2.2"/>
 *	<feOffset dx="12" dy="12" result="offsetblur"/>
 *	<feFlood flood-color="rgba(0,0,0,0.5)"/>
 *	<feComposite in2="offsetblur" operator="in"/>
 *	<feMerge>
 *		<feMergeNode/>
 *		<feMergeNode in="SourceGraphic"/>
 *	</feMerge>
 * </filter>
 * @param node The node on which the filter will be attached
 */
export var createShadowFilter = function (node) {
    //Creation of icon shadow
    var filter = node
        .append('filter')
        .attr('id', 'icon-shadow');
    filter.append('feGaussianBlur')
        .attr('in', 'SourceAlpha')
        .attr('stdDeviation', 2.2);
    filter.append('feOffset')
        .attr('dx', 2)
        .attr('dy', 2)
        .attr('result', 'offsetblur');
    filter.append('feFlood')
        .attr('flood-color', 'rgba(0,0,0,0.5)');
    filter.append('feComposite')
        .attr('in2', 'offsetblur')
        .attr('operator', 'in');
    var mergeFilter = filter.append('feMerge');
    mergeFilter.append('feMergeNode');
    mergeFilter.append('feMergeNode')
        .attr('in', 'SourceGraphic');
};
